<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div class="box" v-else>
      <div class="main-nav">化肥二维码质量追溯平台</div>
      <div class="minor-nav">{{tabs.index=== 0?'化肥':''}}{{tabs.list[tabs.index].tit}}</div>

      <!-- 溯源信息 -->
      <div class="list" v-if="tabs.index === 0">
        
          <ul class="row">
            <li class="label">肥料名称：</li>
            <li class="value">{{datas.product.name}}</li>
          </ul>
          <ul class="row">
            <li class="label">生产商：</li>
            <li class="value">{{datas.business.name}}</li>
          </ul>

          <!-- 基本信息 -->
          <template v-if="!showDetail">
            <ul class="row">
              <li class="label">产品识别码：</li>
              <li class="value">{{datas.code}}</li>
            </ul>
            <ul class="row">
              <li class="label">查询次数：</li>
              <li class="value">{{datas.scan_count}}次</li>
            </ul>
            <ul class="row">
              <li class="label">追溯网址：</li>
              <li class="value active" @click="showDetail=true">https://lj.oid.plus/?{{datas.code}}</li>
            </ul>
          </template>

          <!-- 详情 -->
          <template v-else>
            <ul class="row" v-for="(item, index) in datas.product.attribute" :key="index">
              <li class="label">{{item.key}}：</li>
              <li class="value">{{item.value}}</li>
            </ul>
            <ul class="row">
              <li class="label"></li>
              <li class="value active" @click="showDetail=false">{{`<返回基本信息`}}</li>
            </ul>
          </template>

          <ul class="row">
            <li class="img-box"><img :src="datas.product.img" /></li>
          </ul>
      </div>

      <!-- 公司简介 -->
      <div class="list" v-if="tabs.index === 1">
        <template v-for="(item, index) in datas.business.customize_data">
          <ul class="row" v-if="!item.value.includes('media')">
            <li class="label">{{item.key}}：</li>
            <li class="value">{{ item.value }}</li>
          </ul>
        </template>
      </div>

      <!-- 荣誉证书 -->
      <div class="list" v-if="tabs.index === 2">
        <template v-for="(item, index) in datas.business.customize_data">
          <ul class="row" v-if="item.value.includes('media')">
              <li class="img-box"><img :src="item.value" /></li>
          </ul>
        </template>
      </div>

      <!-- 技术支持 -->
      <div class="flex-row support">
        <p>技术支持：</p>
        <p>链接科技有限公司</p>
      </div>


      <div class="tabs">
        <p @click="tabs.index = index;" :class="{active: tabs.index === index}" v-for="(item, index) in tabs.list">{{ item.tit }}</p>
      </div>

    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import AlertMsg from '@/components/AlertMsg.vue'
import Form from '@/components/Form.vue'
import mixin from '../mixins/mixin.js'
export default {
  name: 'Pesticide06',
  components: {
    'K-Loading': Loading,
    'K-AlertMsg': AlertMsg,
    'K-Form': Form,
  },
  mixins: [mixin],
  data() {
    return {
      showDetail: false,
      tabs: {
        index: 0,
        list: [{
          tit: '溯源信息',
        },{
          tit: '公司简介'
        },{
          tit: '荣誉证书'
        }]
      }
    }
  },
  created() {
    this.initData();
  },
  methods: {
    async initData(){
      //判断是演示还是真实码标
      if (this.$route.query.type == "demo") {
        const pid = this.$route.query.pid; //产品ID
        const rid = this.$route.query.rid; //企业ID
        this.GetDemoDatas(pid, rid);  //获取演示模板信息
      } else {
        await this.GetDatas();  //获取码标信息
        console.log(this.datas);
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .box{
  	min-height: 100vh;
    background-color: #FFF;
    padding: 18px;
    font-size: 16px;
  }

  .flex-row{
    display: flex;
  }
  .support{
    margin-top: 20px;
    justify-content: center;
    font-size: 15px;
    color: #666;
    .active{
      color: #317ef3;
    }
  }

  .main-nav{
    font-size: 20px;
    height: 50px;
    background: #014e30;
    color: #fff;
    line-height: 50px;
    text-align: center;
  }

  .minor-nav{
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background: #0fa168;
    font-size: 18px;
    margin-top: 50px;
  }

  .list{
    margin-top: 20px;
    padding: 0 10px;
    .active{
      color: #317ef3;
      text-decoration: underline;
    }
    .row{
      display: flex;
      align-items: flex-start;
      margin-bottom: 8px;
      line-height: 22px;
      word-break: break-all;
      .label{
        width: 100px;
        text-align: right;
        margin-right: 5px;
      }
      .value{
        width: calc(100% - 100px);
      }
      .img-box{
        display: table;
        margin: auto;
        width: 80%;
        img{
          width: 100%;
          display: block;
        }
      }
    }
  }


  .tabs{
    display: flex;
    padding: 20px 25px;
    margin-top: 80px;
    font-size: 18px;
    color: #888;
    text-decoration: underline;
    justify-content: space-between;
    .active{
      color: #0fa168;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Pesticide07.vue